/* VATNARA Cart-Overlay — 2026-09-16
 * Faengt das Add-to-Cart-Formular ab und zeigt den Warenkorb als Overlay,
 * statt auf /cart weiterzuleiten.
 *
 * Grundsatz: Progressive Enhancement. Schlaegt irgendetwas fehl, laeuft das
 * Formular ganz normal weiter und der Kunde landet wie bisher auf /cart.
 * Es geht also nie ein Kauf verloren, nur weil dieses Skript hakt.
 *
 * Alle Texte stammen woertlich von der Produktseite (Reviews, Versandzusage,
 * Garantien). Nichts davon ist hier erfunden.
 */
(function () {

  /* Rabatt-Timer auch im Warenkorb (Stefan 19.09.) — gleicher Zaehler wie auf der PDP (localStorage vt_code_start) */
  function vtWin(key, secs) { var s; try { s = parseInt(localStorage.getItem(key), 10); } catch (x) {} var l = s ? secs - Math.floor((Date.now() - s) / 1000) : 0; if (l <= 0) { try { localStorage.setItem(key, String(Date.now())); } catch (x) {} l = secs; } return l; }
  /* 19.09. (Owner): Timer laeuft in Schleife statt 'ends soon'; nach Anwenden 15-Min-Preissperre */
  function vtApplied() { return document.cookie.indexOf('discount_code=WELCOME10') > -1 || window.VT_CODE === true; }
  function vtLeft() { return vtApplied() ? vtWin('vt_lock_start', 900) : vtWin('vt_code_start', 600); }
  function vtFmt(l) { var m = Math.floor(l / 60), s = l % 60; return m + ':' + (s < 10 ? '0' : '') + s; }
  function vtCodeBox() {
    var applied = document.cookie.indexOf('discount_code=WELCOME10') > -1, l = vtLeft();
    var t = l > 0 ? '<b class="vcd__timer">' + vtFmt(l) + '</b>' : '<b class="vcd__timer">ends soon</b>';
    if (applied) return '<div class="vcd__code vcd__code--on">&#127873; WELCOME10 &minus;10% applied &middot; &#128274; price locked for ' + t + '</div>';
    return '<button type="button" class="vcd__code vcd__code--tap" id="vcdCode">&#127873; Extra 10% off &middot; code <u>WELCOME10</u> &middot; ' + t + '<small>tap to apply</small></button>';
  }
  setInterval(function () { var l = vtLeft(); document.querySelectorAll('.vcd__timer').forEach(function (e) { e.textContent = l > 0 ? vtFmt(l) : 'ends soon'; }); }, 1000);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#vcdCode'); if (!b) return;
    fetch('/discount/WELCOME10', { credentials: 'same-origin' }).then(function () { window.VT_CODE = true; try { localStorage.setItem('vt_lock_start', String(Date.now())); } catch (x) {}
      b.outerHTML = '<div class="vcd__code vcd__code--on">&#127873; WELCOME10 &minus;10% applied &middot; &#128274; price locked for <b class="vcd__timer">' + vtFmt(vtLeft()) + '</b></div>'; }).catch(function () {});
  });
  'use strict';

  var REVIEWS = [
    { img: 'c1', text: 'After conditioning my hair used to feel like velcro — no slip at all, impossible to brush. I\'d started to feel like I looked like I didn\'t take care of myself. That\'s the part I don\'t miss.',
      who: 'MAYA R. · SALT LAKE CITY, UT · 7 WEEKS IN' },
    { img: 'c3', text: 'Same shampoo, same routine, new apartment — and my hair started feeling like straw. The drop test the first night: tap yellow, filtered clear.',
      who: 'LENA K. · DENVER, CO · 6 WEEKS IN' },
    { img: null, text: 'I used to get stuck halfway down and just yank. Now the brush goes through in one pass. That is the whole review.',
      who: 'RAE T. · TAMPA, FL · 3 WEEKS IN' }
  ];

  var assets = (window.VATNARA_CART_ASSETS || {});
  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  var scrim, drawer, bodyEl, isOpen = false, lastFocus = null;

  function build() {
    scrim = document.createElement('div');
    scrim.className = 'vcd-scrim';
    scrim.addEventListener('click', close);

    drawer = document.createElement('aside');
    drawer.className = 'vcd';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Your cart');
    drawer.innerHTML =
      '<div class="vcd__grab"></div>' +
      '<div class="vcd__top"><h3>Your cart</h3>' +
      '<button class="vcd__close" aria-label="Close">Close</button></div>' +
      '<div class="vcd__body"></div>' +
      '<div class="vcd__foot"></div>';

    document.body.appendChild(scrim);
    document.body.appendChild(drawer);
    bodyEl = drawer.querySelector('.vcd__body');
    drawer.querySelector('.vcd__close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
    });
  }

  function faces() {
    if (!assets.c4) return '';
    return '<div class="vcd__faces">' +
      ['c1', 'c2', 'c3', 'c4'].map(function (k) {
        return assets[k] ? '<img src="' + assets[k] + '" alt="">' : '';
      }).join('') + '</div>';
  }

  function render(cart) {
    if (!cart || !cart.item_count) {
      bodyEl.innerHTML = '<p class="vcd__empty">Your cart is empty.</p>';
      drawer.querySelector('.vcd__foot').innerHTML = '';
      return;
    }

    var items = cart.items.map(function (i) {
      return '<div class="vcd__row">' +
        (i.image ? '<img class="vcd__thumb" src="' + i.image + '" alt="">' : '<div class="vcd__thumb"></div>') +
        '<div><div class="vcd__nm">' + escapeHtml(i.product_title) + '</div>' +
        (i.variant_title ? '<div class="vcd__plan">' + escapeHtml(i.variant_title) + '</div>' : '') +
        (i.variant_id === 54823102415189 ? '<div class="vcd__save">Plan saves $20 vs. one-time</div>' : '') +
        '</div><div class="vcd__pr">' + (i.variant_id === 54823102415189 ? '<s class="vcd__was">$149.00</s>' : '') + money(i.final_line_price) + '</div></div>';
    }).join('');

    var MAIN_PRODUCT = 11558682788181, ADDON_VARIANT = 55042347499861;
    var hasMain = cart.items.some(function (i) { return i.product_id === MAIN_PRODUCT; });
    var hasAddon = cart.items.some(function (i) { return i.variant_id === ADDON_VARIANT; });
    var upsell = (hasMain && !hasAddon) ?
      '<div class="vcd__up"><img src="' + (assets.pack || '') + '" alt="">' +
      '<div><b>Second bathroom?</b><span>Add another filter + cartridge for <s>$129</s> <em>$99</em></span></div>' +
      '<button type="button" class="vcd__upbtn" data-addon="' + ADDON_VARIANT + '">Add</button></div>' : '';

    var tst = REVIEWS.map(function (r) {
      return '<div class="vcd__tst">' +
        (assets[r.img] ? '<img src="' + assets[r.img] + '" alt="">' : '') +
        '<div><p>&ldquo;' + escapeHtml(r.text) + '&rdquo;</p>' +
        '<div class="vcd__who">' + escapeHtml(r.who) + '</div></div></div>';
    }).join('');

    bodyEl.innerHTML =
      '<div class="vcd__proof">' + faces() +
        '<div><div class="vcd__stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>' +
        '<div class="vcd__proofTxt">Trusted by 100+ households</div>' +
        '<div class="vcd__proofSub">4.8 average &middot; verified buyers</div></div></div>' +
      items + vtCodeBox() + upsell +
      '<div class="vcd__terms">' +
        '<span>Free US shipping</span><i>&middot;</i>' +
        '<span>60 days to decide</span><i>&middot;</i>' +
        '<span>Cancel in one click</span>' +
      '</div>' +
      '<div class="vcd__ship"><b>Free US delivery</b>' +
        '<span>Most orders arrive in 3 &ndash; 4 business days</span></div>' +
      '<div class="vcd__sec">What buyers say</div>' + tst;

    var ub = bodyEl.querySelector('.vcd__upbtn');
    if (ub) ub.addEventListener('click', function () {
      ub.disabled = true; ub.textContent = '…';
      var fd = new FormData(); fd.append('id', ub.getAttribute('data-addon')); fd.append('quantity', '1');
      try { var u = window.VT_UTM || {}; Object.keys(u).forEach(function (k) { fd.append('properties[_' + k + ']', u[k]); }); fd.append('properties[_upsell]', 'drawer-2nd-filter'); } catch (x) {}
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); }).then(render)
        .catch(function () { ub.disabled = false; ub.textContent = 'Add'; });
    });

    drawer.querySelector('.vcd__foot').innerHTML =
      '<div class="vcd__tot"><span>Total</span><span>' + money(cart.total_price) + ' USD</span></div>' +
      '<a class="vcd__btn" href="/checkout">&#128274; Secure checkout</a>' +
      (window.VATNARA_PAY ? '<div class="vcd__pay">' + window.VATNARA_PAY + '</div>' : '') +
      '<div class="vcd__fine">Taxes and shipping calculated at checkout</div>';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function open() {
    if (!drawer) build();
    scrim.setAttribute('data-open', '');
    drawer.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
    isOpen = true;
    lastFocus = document.activeElement;
    var btn = drawer.querySelector('.vcd__close');
    if (btn) btn.focus();
  }

  function close() {
    if (!drawer) return;
    scrim.removeAttribute('data-open');
    drawer.removeAttribute('data-open');
    document.body.style.overflow = '';
    isOpen = false;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function loadAndOpen() {
    if (!drawer) build();
    open();
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { window.location.href = '/cart'; });
  }

  function bindForm(form) {
    if (form.dataset.vcdBound) return;
    form.dataset.vcdBound = '1';
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;              // altes Geraet -> normaler Submit
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"], button');
      var label = btn ? btn.innerHTML : null;
      if (btn) { btn.disabled = true; btn.style.opacity = '.7'; }

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () { loadAndOpen(); })
        .catch(function () { form.submit(); })   // Rueckfall: ganz normal auf /cart
        .finally(function () {
          if (btn) { btn.disabled = false; btn.style.opacity = ''; if (label) btn.innerHTML = label; }
        });
    });
  }

  function init() {
    // Das Hinzufuegen selbst macht vatnara-v2-app.js (AJAX auf /cart/add.js).
    // Wir stellen nur das Oeffnen bereit; faellt das hier aus, geht app.js
    // weiterhin auf /cart und der Kauf laeuft normal weiter.
    window.VATNARA_OPEN_CART = loadAndOpen;

    // Cart-Knopf im Kopf oeffnet ebenfalls das Overlay
    document.querySelectorAll('.hdr__cartbtn, [data-vcd-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); loadAndOpen(); });
    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
